(() => {
  if (customElements.get('lawson-freight-quote')) return;
  const savedDelivery = {};
  customElements.define('lawson-freight-quote', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-freight-cart]').textContent);
      this.fields = Object.fromEntries([...this.querySelectorAll('[data-freight-field]')].map(el => [el.dataset.freightField, el]));
      for (const [key,value] of Object.entries(savedDelivery)) {
        if (!this.fields[key]) continue;
        if (this.fields[key].type === 'checkbox') this.fields[key].checked = value;
        else this.fields[key].value = value;
      }
      this.form = this.querySelector('#CartFreightQuote');
      this.setupPayment();
      const update = () => {
        const business = this.fields.method.value === 'business';
        this.querySelector('[data-freight-business]').hidden = !business;
        const tailgateNote = this.querySelector('[data-freight-tailgate]');
        if (tailgateNote) tailgateNote.hidden = this.fields.unloading?.value !== 'tailgate';
        this.fields.company.required = business;
        this.fields.company.disabled = !business;
        this.summary();
      };
      this.form.addEventListener('change', update);
      this.form.addEventListener('input', () => this.summary());
      this.form.addEventListener('submit', () => this.summary());
      update();
    }
    setupPayment() {
      const form = this.querySelector('[data-freight-payment]');

      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (!form.reportValidity()) return;
        const button = form.querySelector('button');
        const error = form.querySelector('[data-freight-payment-error]');
        button.disabled = true; error.hidden = true;
        try {
          const attributes = Object.fromEntries([...new FormData(form)].filter(([key]) => key.startsWith('attributes[')).map(([key,value]) => [key.slice(11,-1),value]));
          const response = await fetch(form.action.replace(/\/cart\/?$/, '/cart/update.js'), {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes:{...attributes,'Freight terms accepted':'','Delivery destination':'','Unloading':''}})});
          if (!response.ok) throw new Error('Could not save delivery preference');
          const cart = await response.json();
          if (!cart.item_count || cart.attributes['Delivery preference'] !== 'Freight quoted separately') throw new Error('Cart not ready');
          window.location.assign(form.action.replace(/\/cart\/?$/, '/checkout'));
        } catch (e) { error.hidden = false; button.disabled = false; }
      });
    }
    summary() {
      for (const [key,field] of Object.entries(this.fields)) savedDelivery[key] = field.type === 'checkbox' ? field.checked : field.value;
      const { labels, items, currency, total, note } = this.data;
      const money = value => new Intl.NumberFormat('en-AU', { style:'currency', currency }).format(value / 100);
      const lines = [labels.cart_heading];
      for (const item of items) {
        lines.push(`${item.quantity} x ${item.title}${item.variant && item.variant !== 'Default Title' ? ' / ' + item.variant : ''}: ${money(item.price)}`);
        if (item.sku) lines.push('SKU: ' + item.sku);
        const properties = Array.isArray(item.properties) ? item.properties : Object.entries(item.properties || {});
        for (const [key,value] of properties) if (!key.startsWith('_') && value !== '') lines.push(key + ': ' + value);
      }
      lines.push(labels.products_total + ': ' + money(total));
      if (note) lines.push(labels.notes + ': ' + note);
      const method = this.fields.method.value;
      if (method) lines.push(labels.delivery_method + ': ' + labels[method]);
      for (const key of ['suburb','postcode','state','notes']) if (this.fields[key].value.trim()) lines.push(labels[key] + ': ' + this.fields[key].value.trim());
      if (method === 'business') {
        if (this.fields.company.value.trim()) lines.push(labels.company + ': ' + this.fields.company.value.trim());

      }
      if (this.fields.unloading?.value) lines.push(labels.unloading + ': ' + labels[this.fields.unloading.value]);
      this.querySelector('[data-freight-body]').value = lines.join('\n');
    }
  });
})();
